import React from 'react'

import { Hidden } from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person'

import { GET_BOX_CLICK, NAVIGATION } from 'artkive/constants/tracker/mainNavigation'
import useSale from 'artkive/hooks/useSale'
import routes from 'artkive/utils/routes'

import { AccountButton, BrandsBox } from '../BrandsBanner/BrandsBanner.style'

import { SaleBannerButton, SaleText, Wrapper } from './SaleBanner.style'

const SaleBanner = () => {
  const { name, priceLabel, boxCheckoutUrl, announcementBar } = useSale()

  return (
    <Wrapper bgColor={announcementBar.background}>
      {/* empty block for correct layout*/}
      <div></div>
      <BrandsBox>
        <SaleText variant='body2' style={{ color: announcementBar.color }}>
          {name}:
          <SaleBannerButton
            href={boxCheckoutUrl}
            textColor={announcementBar.color}
            trackerEvent={GET_BOX_CLICK}
            trackerOptions={{ section: 'top_header_sale_button' }}
          >
            {priceLabel} Artkive Box
          </SaleBannerButton>
          🎉
        </SaleText>
      </BrandsBox>
      <Hidden smDown>
        <AccountButton startIcon={<PersonIcon />} href={routes.accountOrders} trackerEvent={NAVIGATION.MY_ORDERS_CLICK}>
          My Account
        </AccountButton>
      </Hidden>
    </Wrapper>
  )
}

export default SaleBanner
